export default __webpack_public_path__ + "static/media/job.e02c369c.svg";